module.exports = __webpack_public_path__ + "static/media/settlements_example.2cde881f.csv";